import { useHeaders } from "hooks/api/useHeaders";
import { useMutation } from "react-query";
import { approveAdMaterialReq } from "api";

export const useApproveAdMaterial = () => {
    const headers = useHeaders();

    return useMutation((id: number) => approveAdMaterialReq(headers, id));
};
